import React from 'react';
import { motion } from 'framer-motion';
import LoadingSpinner from './LoadingSpinner';

const PageLoader = ({ text = '', variant = 'default' }) => {
  return (
    <div className="h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50/30">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="text-center"
      >
        <LoadingSpinner size="xl" variant={variant} text={text} />
      </motion.div>
    </div>
  );
};

export default PageLoader;
